import ImageWithFallback from "@/Component/Common/ImageWithFallback";
import moment from "moment";
import Link from "next/link";
import { FaFilePdf } from "react-icons/fa";
import { RiFilePdf2Line, RiFilePdfFill } from "react-icons/ri";

const DisputeBox = (props) => {
    const { data, userDetails } = props;
    return (
        <div className="border border-lightGray rounded-xl p-4 grid grid-cols-12 gap-3 mb-3 bg-white shadow">
            <div className="col-span-9">
                <div className="grid grid-cols-12 gap-3">
                    <div className="col-span-7">
                        <div className='flex items-center gap-4 mb-4'>
                            <div className='min-w-14 w-14 h-14 rounded-full overflow-hidden bg-gray'>
                                <ImageWithFallback src={data?.dispute_by?.image} alt='Profile' className='w-full h-full object-cover' height={70} width={70} />
                            </div>
                            <div className='flex flex-col'>
                                {data?.dispute_by?.role == 'brand' ? <h5 className='font-semibold text-lg'>{data?.dispute_by?.first_name} {data?.dispute_by?.last_name}</h5> : <h5 className='font-semibold text-xl'>{data?.dispute_by?.first_name} {data?.dispute_by?.last_name} ({data?.dispute_by?.display_name})</h5>}
                                <span className='text-gray text-sm'>{data?.dispute_by?.country}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-5">
                        <label className="font-medium block text-sm">Reason:</label>
                        <p className='text-sm'>{data?.reason}</p>
                    </div>
                </div>
            </div>
            <div className="col-span-3">
                <label className="font-medium block text-sm">Attachment:</label>
                <div className="grid grid-cols-3 gap-2">
                    {data?.attachment?.map((file, ind) => (
                        <div className="aspect-square bg-gray/25 h-max" key={ind}>
                            {file?.fileType === 'image' ?
                                <Link href={userDetails?.dispute_path + file?.fileName} target="_blank" rel="noreferrer">
                                    <ImageWithFallback src={userDetails?.dispute_path + file?.fileName} alt='Profile' className='w-full h-full object-contain' height={70} width={70} />
                                </Link>
                                :
                                <Link href={userDetails?.dispute_path + file?.fileName} target="_blank" rel="noreferrer" className="flex items-center justify-center w-full h-full">
                                    <FaFilePdf className='text-3xl text-red-500' />
                                </Link>
                            }
                        </div>
                    ))}
                </div>
            </div>
            <div className="col-span-12">
                <p className='text-sm'>{data?.description}</p>
            </div>
            <div className="col-span-12">
            <label className="font-medium block text-sm">Dispute On:</label>
                <p className='text-sm'>{moment.utc(data?.created_at).local().format('DD MMM YYYY h:mm A')}</p>
            </div>
        </div>
    )
}

export default DisputeBox
